<script>
import { authComputed, authFackMethods, masterMethods, campaignMethods } from '@/state/helpers';
import { ID_ROLE_FIXED } from '@/config/constants';

import Layout from '@/views/layouts/main';
import DashboardAdmin from './admin/main.vue';
import DashboardSaleAndInstructor from './sales/main.vue';
import DashboardEmployee from './employee-part-time/main.vue';
import DashboardPartner from './partner/main.vue';
import DashboardManagerNumberProject from './manager/main.vue';

export default {
    components: {
        Layout,
        DashboardAdmin,
        DashboardSaleAndInstructor,
        DashboardEmployee,
        DashboardPartner,
        DashboardManagerNumberProject
    },
    data() {
        return {
            diffTable: false,
            textButton: '案件数管理',
            isHandleRemoveBookmark: false,
            userInfo: null,
            ID_ROLE_FIXED
        };
    },
    computed: {
        ...authComputed
    },
    methods: {
        ...authFackMethods,
        ...masterMethods,
        ...campaignMethods,

        handleChangeTable() {
            if (this.diffTable) {
                this.textButton = '案件数管理';
            } else {
                this.textButton = '戻る';
            }
            this.diffTable = !this.diffTable;
        },

        handleGetDetailBookmark(obj) {
            this.$router.push({
                path: '/campaign/form/view',
                query: {
                    id: obj.id
                }
            });
        },

        async handleRemoveBookmark(obj) {
            if (this.isHandleRemoveBookmark) return;
            this.isHandleRemoveBookmark = true;
            try {
                this.userInfo.campaign_bookmarks = this.userInfo.campaign_bookmarks.filter((item) => item.id !== obj.id);
                localStorage.setItem('user', JSON.stringify(this.userInfo));
                await this.unsetBookmarkCampaign(obj.id);
            } catch (error) {
                console.log(error);
            } finally {
                this.isHandleRemoveBookmark = false;
            }
        }
    },
    mounted() {
        this.userInfo = JSON.parse(localStorage.getItem('user'));
    }
};
</script>

<template>
    <Layout>
        <div class="row form__common--center">
            <div class="col-lg-12 dashboard__main">
                <div class="card">
                    <div class="card-body">
                        <div v-if="this.userInfo?.campaign_bookmarks?.length > 0">
                            <div class="list--bookmark mt-4">
                                <div class="col-sm-12 row" style="gap: 12px; flex-wrap: nowrap; overflow: hidden">
                                    <div v-for="(bookmark, idx) in this.userInfo.campaign_bookmarks" :key="idx">
                                        <div class="d-flex" style="gap: 3px; min-width: 210px">
                                            <p class="mb-0">
                                                <i class="ri-bookmark-fill" style="color: #157efb"></i>
                                            </p>
                                            <div class="d-flex" data-toggle="tooltip" :title="bookmark.name">
                                                <p class="name__bookmark" @click="handleGetDetailBookmark(bookmark)">
                                                    {{ bookmark.name }}
                                                </p>
                                            </div>
                                            <p class="remove__bookmark mb-0" @click="handleRemoveBookmark(bookmark)">
                                                <i class="ri-close-fill"></i>
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div class="list--more">
                                    <p id="popover-button-variant" tabindex="0">
                                        <i class="fa fa-angle-double-right"></i>
                                    </p>
                                    <b-popover
                                        target="popover-button-variant"
                                        variant="null"
                                        placement="bottom"
                                        triggers="hover focus"
                                        custom-class="more--bookmark"
                                    >
                                        <template #title>{{ $t('pageDashboard.more') }}</template>
                                        <div class="box-list" :style="`height: ${this.userInfo?.campaign_bookmarks?.length > 10 ? '500px' : '100%'}`">
                                            <div
                                                v-for="(bookmark, idx) in this.userInfo.campaign_bookmarks"
                                                :key="idx"
                                                style="display: flex; flex-wrap: nowrap; gap: 5px"
                                            >
                                                <span>
                                                    <i class="ri-bookmark-fill" style="color: #157efb"></i>
                                                </span>
                                                <div class="d-flex" data-toggle="tooltip" :title="bookmark.name">
                                                    <p @click="handleGetDetailBookmark(bookmark)">
                                                        {{ bookmark.name }}
                                                    </p>
                                                    <span class="remove__bookmark" @click="handleRemoveBookmark(bookmark)">
                                                        <i class="ri-close-fill"></i>
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </b-popover>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="currentUser?.role?.id === 1">
                    <div class="text-right my-3">
                        <button v-if="textButton == '戻る'" class="btn btn-common btn-primary" style="min-width: 76px" @click="handleChangeTable">
                            <i class="ri-arrow-left-line"></i>{{ textButton }}
                        </button>
                        <button v-else class="btn btn-common btn-info" @click="handleChangeTable">
                            {{ textButton }}
                        </button>
                    </div>
                    <DashboardAdmin v-if="!diffTable" />
                    <DashboardManagerNumberProject v-else />
                </div>
                <DashboardSaleAndInstructor
                    :screen="currentUser?.role?.id"
                    v-if="[ID_ROLE_FIXED.ADMIN, ID_ROLE_FIXED.SALE_INSTRUCTOR].includes(currentUser?.role?.id)"
                />
                <DashboardEmployee v-if="currentUser?.role?.id === ID_ROLE_FIXED.PART_TIME" />
                <DashboardPartner
                    v-if="
                        [
                            ID_ROLE_FIXED.EXTERNAL_PARTNER,
                            ID_ROLE_FIXED.INQUIRY_PARTNER,
                            ID_ROLE_FIXED.OFFICE_PARTNER,
                            ID_ROLE_FIXED.SHIPPING_PARTNER,
                            ID_ROLE_FIXED.OFFICE_SHIPPING_PARTNER
                        ].includes(currentUser?.role?.id)
                    "
                />
            </div>
        </div>
    </Layout>
</template>
<style lang="scss" scoped>
.remove__bookmark {
    cursor: pointer;
    i {
        font-size: 15px;
        &:hover {
            backdrop-filter: contrast(0.5);
            color: #ca3d3d;
        }
    }
}
.list--bookmark {
    position: relative;
}

.list--more {
    user-select: none;
    position: absolute;
    right: 0;
    top: 0;
    background-color: #ffff;
    padding: 0px 12px;
    p {
        cursor: pointer;
        &:hover {
            color: #101111;
            transition: all 0.3s ease-in-out;
        }
    }
}

.name__bookmark {
    font-size: 14px;
    white-space: nowrap;
    width: 260px;
    overflow: hidden;
    text-overflow: ellipsis;
    cursor: pointer;
}

.more--bookmark .popover-body {
    .box-list {
        width: 260px;
        overflow: hidden;
        overflow-y: auto;

        &::-webkit-scrollbar {
            width: 12px;
            background-color: #f5f5f5;
        }
        &::-webkit-scrollbar {
            width: 6px;
            background-color: #f5f5f5;
        }
        &::-webkit-scrollbar-thumb {
            border-radius: 10px;
            -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
            background-color: #c1c1c1dc;
        }
    }
}
</style>
<style lang="scss">
.popover.more--bookmark {
    z-index: 999;
}
</style>
